import { useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import Button from 'components/Button'
import Dropdown from 'components/Dropdown'
import { VOUCHER_TYPES_DROPDOWN } from 'constants/filters'

export type VoucherFilterFormTypes = {
  voucherTypeId: number | null
}

export const VoucherListFilterForm = ({
  onFilter,
  onClear,
  defaultValues,
}: {
  onFilter: (params: VoucherFilterFormTypes) => void
  onClear: () => void
  defaultValues: VoucherFilterFormTypes
}) => {
  const { control, handleSubmit, reset } = useForm<VoucherFilterFormTypes>({
    defaultValues,
  })

  useEffect(() => {
    reset(defaultValues)
  }, [defaultValues, reset])

  const handleClear = () => {
    reset({ voucherTypeId: null })
    onClear()
  }

  return (
    <form onSubmit={handleSubmit(onFilter)} className="flex gap-4 items-end mb-4">
      <Controller
        control={control}
        name="voucherTypeId"
        render={({ field: { onChange, value } }) => {
          const selectedOption =
            value != null
              ? VOUCHER_TYPES_DROPDOWN.find(opt => Number(opt.value) === value)
              : null

          return (
            <Dropdown
              title=""
              options={VOUCHER_TYPES_DROPDOWN}
              placeholder="Select Voucher Type"
              containerClassName="w-96"
              value={selectedOption}
              onSelect={(option) => onChange(option ? Number(option.value) : null)}
            />
          )
        }}
      />
      <Button type="submit" className="rounded bg-primary font-bold">
        Filter
      </Button>
      <Button type="button" className="rounded border" onClick={handleClear}>
        Clear
      </Button>
    </form>
  )
}

export default VoucherListFilterForm
